var _defs, _rect, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSsCompanyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39d353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#18c4e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1689ed"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 88,
    fill: "#071f2b"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 290,
    fill: "url(#brand)",
    fontFamily: "Arial, sans-serif",
    fontSize: 204,
    fontWeight: 800,
    textAnchor: "middle"
  }, "SS")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 362,
    fill: "#87aab6",
    fontFamily: "Arial, sans-serif",
    fontSize: 32,
    fontWeight: 600,
    textAnchor: "middle"
  }, "COMPANY")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsCompanyLogo);
export default __webpack_public_path__ + "static/media/ss-company-logo.79421bbc329170ae11a29c8f1a840a7c.svg";
export { ForwardRef as ReactComponent };